// Country -> default UI language. Used to auto-set language at registration.
// Covers all EU member states + UK + the Americas + Australia + New Zealand + South Africa + India.
export const COUNTRIES = [
  // --- European Union ---
  { name: "Austria", lang: "de" },
  { name: "Belgium", lang: "nl" },
  { name: "Bulgaria", lang: "bg" },
  { name: "Croatia", lang: "hr" },
  { name: "Cyprus", lang: "el" },
  { name: "Czech Republic", lang: "cs" },
  { name: "Denmark", lang: "da" },
  { name: "Estonia", lang: "et" },
  { name: "Finland", lang: "fi" },
  { name: "France", lang: "fr" },
  { name: "Germany", lang: "de" },
  { name: "Greece", lang: "el" },
  { name: "Hungary", lang: "hu" },
  { name: "Ireland", lang: "en" },
  { name: "Italy", lang: "it" },
  { name: "Latvia", lang: "lv" },
  { name: "Lithuania", lang: "lt" },
  { name: "Luxembourg", lang: "fr" },
  { name: "Malta", lang: "mt" },
  { name: "Netherlands", lang: "nl" },
  { name: "Poland", lang: "pl" },
  { name: "Portugal", lang: "pt" },
  { name: "Romania", lang: "ro" },
  { name: "Slovakia", lang: "sk" },
  { name: "Slovenia", lang: "sl" },
  { name: "Spain", lang: "es" },
  { name: "Sweden", lang: "sv" },
  // --- United Kingdom ---
  { name: "United Kingdom", lang: "en" },
  // --- North America ---
  { name: "United States", lang: "en" },
  { name: "Canada", lang: "en" },
  { name: "Mexico", lang: "es" },
  // --- Central America & Caribbean ---
  { name: "Antigua and Barbuda", lang: "en" },
  { name: "Bahamas", lang: "en" },
  { name: "Barbados", lang: "en" },
  { name: "Belize", lang: "en" },
  { name: "Costa Rica", lang: "es" },
  { name: "Cuba", lang: "es" },
  { name: "Dominica", lang: "en" },
  { name: "Dominican Republic", lang: "es" },
  { name: "El Salvador", lang: "es" },
  { name: "Grenada", lang: "en" },
  { name: "Guatemala", lang: "es" },
  { name: "Haiti", lang: "fr" },
  { name: "Honduras", lang: "es" },
  { name: "Jamaica", lang: "en" },
  { name: "Nicaragua", lang: "es" },
  { name: "Panama", lang: "es" },
  { name: "Saint Kitts and Nevis", lang: "en" },
  { name: "Saint Lucia", lang: "en" },
  { name: "Saint Vincent and the Grenadines", lang: "en" },
  { name: "Trinidad and Tobago", lang: "en" },
  // --- South America ---
  { name: "Argentina", lang: "es" },
  { name: "Bolivia", lang: "es" },
  { name: "Brazil", lang: "pt" },
  { name: "Chile", lang: "es" },
  { name: "Colombia", lang: "es" },
  { name: "Ecuador", lang: "es" },
  { name: "Guyana", lang: "en" },
  { name: "Paraguay", lang: "es" },
  { name: "Peru", lang: "es" },
  { name: "Suriname", lang: "nl" },
  { name: "Uruguay", lang: "es" },
  { name: "Venezuela", lang: "es" },
  // --- Oceania & Africa ---
  { name: "Australia", lang: "en" },
  { name: "New Zealand", lang: "en" },
  { name: "South Africa", lang: "en" },
  // --- Asia ---
  { name: "India", lang: "hi" },
];

export function langForCountry(country) {
  const c = COUNTRIES.find((x) => x.name === country);
  return c ? c.lang : "en";
}

export const EU_COUNTRIES = [
  "Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czech Republic", "Denmark",
  "Estonia", "Finland", "France", "Germany", "Greece", "Hungary", "Ireland", "Italy",
  "Latvia", "Lithuania", "Luxembourg", "Malta", "Netherlands", "Poland", "Portugal",
  "Romania", "Slovakia", "Slovenia", "Spain", "Sweden",
];

export function isEUCountry(country) {
  return EU_COUNTRIES.includes(country);
}
